require.register("app/billing/invoice/ListView", function(exports, require, module){
  $0
  
});

